import { api } from './api';

export const architectImagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getArchitectImages: builder.query({
      query: (params = {}) => ({
        url: '/admin/architect-images',
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 10,
          ...(params.search && { search: params.search }),
          ...(params.sortBy && { sortBy: params.sortBy }),
          ...(params.sortOrder && { sortOrder: params.sortOrder }),
        },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'ArchitectImage', id })),
              { type: 'ArchitectImage', id: 'LIST' },
            ]
          : [{ type: 'ArchitectImage', id: 'LIST' }],
    }),
    deleteArchitectImage: builder.mutation({
      query: (id) => ({
        url: `/admin/architect-images/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'ArchitectImage', id },
        { type: 'ArchitectImage', id: 'LIST' },
      ],
    }),
    deleteManyArchitectImages: builder.mutation({
      query: (ids) => ({
        url: '/admin/architect-images/bulk-delete',
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'ArchitectImage', id: 'LIST' }],
    }),
    setFeaturedArchitectImages: builder.mutation({
      query: ({ ids, featured }) => ({
        url: '/admin/architect-images/set-featured',
        method: 'PATCH',
        body: { ids, featured },
      }),
      invalidatesTags: (result, error, { ids }) => [
        ...(ids || []).map((id) => ({ type: 'ArchitectImage', id })),
        { type: 'ArchitectImage', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetArchitectImagesQuery,
  useDeleteArchitectImageMutation,
  useDeleteManyArchitectImagesMutation,
  useSetFeaturedArchitectImagesMutation,
} = architectImagesApi;
